<template>
	<v-card>
		<v-card-title>
			<span class="headline">チケット操作</span>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="10">
					<p class="label-text">生徒名: {{ studentName }}</p>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="10">
					<VmSelect :options="ticketOperationOptions" v-model="selectedOperation" label="操作を選択してください" />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="10">
					<v-select
						:items="ticketNumItems"
						v-model="selectedTicket"
						:label="selectedOperation === 'add' ? 'チケット追加枚数を選択' : 'チケット返却枚数を選択'"
						outlined
						background-color="white"
						hide-details
					></v-select>
					<v-text-field
						:label="selectedOperation === 'add' ? 'チケット追加枚数を入力' : 'チケット返却枚数を入力'"
						v-model="inputtedNum"
						outlined
						background-color="white"
						hide-details
						v-if="selectedTicket === 'その他（手動入力）'"
						type="number"
						:style="{ 'margin-top': '10px' }"
					></v-text-field>
				</v-col>
				<v-col cols="2">
					<p
						class="unit-text"
						:style="selectedTicket === 'その他（手動入力）' ? { 'margin-top': '80px' } : { 'margin-top': '25px' }"
					>
						枚
					</p>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-checkbox v-model="isFeedback" label="フィードバック有" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="blue darken-1" text @click="close">キャンセル</v-btn>
			<v-btn color="blue darken-1" text @click="addTicket">
				{{ selectedOperation === 'add' ? 'チケット追加' : 'チケット返却' }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import VmSelect from '../Atoms/VmSelect.vue'

export default {
	name: 'AdminAddTicketCard',
	components: {
		VmSelect
	},
	data: () => ({
		selectedTicket: null,
		inputtedNum: null,
		ticketNumItems: [5, 10, 15, 'その他（手動入力）'],
		isFeedback: false,
		selectedOperation: 'add',
		ticketOperationOptions: [
			{ label: 'チケット追加', value: 'add' },
			{ label: 'チケット返却', value: 'return' }
		]
	}),
	computed: {
		numberOfAddedTicket() {
			if (this.selectedTicket != 'その他（手動入力）') {
				return this.selectedTicket
			} else {
				return this.inputtedNum
			}
		}
	},
	props: ['studentId', 'studentName'],
	created() {},
	mounted() {
		this.resetForm()
	},
	methods: {
		resetForm() {
			this.selectedTicket = null
			this.inputtedNum = null
			this.isFeedback = false
			this.selectedOperation = 'add'
		},
		close() {
			this.resetForm()
			this.$emit('closeAction')
		},
		addTicket() {
			const addedTicketInfo = {
				studentId: this.studentId,
				numberOfAddedTicket: this.numberOfAddedTicket,
				isFeedback: this.isFeedback,
				isReturn: this.selectedOperation === 'return'
			}

			this.axios
				.post('/api/tickets/addTicketByAdmin', addedTicketInfo)
				.then(() => {
					this.$emit('reloadTable')
					this.close()
				})
				.catch((error) => {
					alert(error)
				})
		},
		changeFile(elem) {
			this.$emit('changeFile', elem)
		}
	}
}
</script>

<style lang="scss" scoped>
p {
	white-space: pre-line;
}
</style>
